// This is our own interface for Inovio's configuration
export interface ApplePayConfig {
  APPLEPAY_CLI_CONF_ID: string;
  REQ_ID: number;
  CLIENT_ID: number;
  INITIATIVE: string;
  DISPLAY_NAME: string;
  PARTNER_MERCH_NAME: string;
  PARTNER_INTERNAL_MERCH_ID: string;
  ENCRYPT_TO: string;
  DOMAIN_LIST: {
    DOMAIN_NAME: string;
    DOMAIN_STATUS: string;
  }[];
  paymentRequest: ApplePayJS.ApplePayPaymentRequest;
  fetchUrl: string;
}

// Custom type for the payment token
export interface ApplePayToken {
  paymentMethod: ApplePayJS.ApplePayPaymentMethod;
  paymentData: {
    data: string;
    signature: string;
    header: {
      ephemeralPublicKey: string;
      publicKeyHash: string;
      transactionId: string;
    };
    version: string;
  };
  transactionIdentifier: string;
}


export const checkIfApplePayIsAvailable = () => {
  try {

    if (window.location.protocol !== "https:") {
      return false;
    }

    const applePaySession = (window as any).ApplePaySession;
    if (!applePaySession) {
      return false;
    }

    return applePaySession.canMakePayments();
  } catch (e) {
    console.error("Error checking Apple Pay availability:", e);
    return false;
  }
};